<mat-card class="title-bordered" id="checkAvailabilityForm">
    <mat-card-content class="no-padding">
        <div class="price-content css-hide-phone css-hide-tablet" id="red-bar" text-color="gray-dark">
        </div>
        <div class="gray-box">
            <div class="date-selector" [style.color]="!product?.isAvailable ? 'grey' : '#3E3E3E'"> 
                <div class="date-selector__container">
                    <div *ngIf="!check.date" class="label" (click)="toggleDatepicker()">
                        <i class="material-icons notranslate">today</i><span>{{'SELECT_DATE' | translate}}</span>
                    </div>
                    <div *ngIf="check.date" class="label" (click)="toggleDatepicker()">
                        <i class="material-icons notranslate">today</i><span>{{check?.date | date: 'dd/MM/yyyy'}}</span>
                    </div>
                </div>
                <div *ngIf="isDateOpened" [style.display]="showDatepicker ? 'none': 'block'">
                    <product-calendar  [(date)]="check.date" [dateSelected]="dateSelected" [isWaiting]="cancelLoading" [changeMonth]="changeMonth" [availableDays]="availableDays" [firstDayAvailable]="firstDayAvailable" (getDays)="getDays($event)" (onChangeDates)="changeDate($event)"></product-calendar>
                </div>
            </div>
            <div class="pax-selector" text-color="gray-dark" [style.color]="!product?.isAvailable ? 'grey' : 'black'">
                <div class="pax-selector__container">
                    <div class="label" (click)="togglePaxDialog(product.id)">
                        <i class="material-icons notranslate">person</i>
                        <div class="pax__units">
                        <ng-container *ngIf="unitsStr == null || unitsStr == ''">
                            <span>{{'SELECT_PEOPLE' | translate}}</span>
                        </ng-container>
                        <ng-container >
                            <span *ngFor="let unit of unitsStr; let isLast=last">{{unit.pax}} x {{unit.name.toUpperCase() | translate}}{{isLast ? '' : ', '}}</span>
                        </ng-container>
                        </div>
                    </div>
                    <div class="pax-row" [hidden]="loadingComponentUnits.isHidden">
                        <loading-component #loadUnits></loading-component>
                    </div>
                </div>
                <div class="pax-selector-open" *ngIf="isPaxSelectorOpened">
                        <!-- <span [hidden]="check?.units?.length > 0 || !loadingComponentUnits.isHidden">{{'NO_AVAILABILITY' | translate}}</span> -->
                        <div class="pax-row__units" *ngFor="let type of check?.units">
                            <div>
                                <label>{{type.name | translate}}</label>
                                <label class="age" *ngIf="type.personType.id != 8 && type.personType.id != 6">{{type.personType.maxAge==null?type.personType.minAge+'+':'( '+type.personType.minAge+' - '+type.personType.maxAge+'
                                    ) '}}</label>
                                <label class="age" *ngIf="type.personType.id == 8">2 {{'ADULT' | translate}}, {{type.personType.minAge}} {{'CHILD' | translate}}</label>
                                <label class="age" *ngIf="type.personType.id == 6">({{'CARD_REQUIRED' | translate}})</label>
                            </div>
                            <div class="units-selector">
                                <span>
                                    <mat-icon class="notranslate" attr.text-color="{{type.pax==0?'gray-opt':'primary'}}" (click)="removeUnit(type)">remove_circle_outline</mat-icon>
                                    <i class="notranslate">{{type.pax}}</i>
                                    <mat-icon class="notranslate" text-color="primary" (click)="addUnit(type)">add_circle_outline</mat-icon>
                                </span>
                            </div>
                        </div>
                    </div>
            </div>
            <div class="pax-btn">
                <button (click)="bookNowClick(check)" color="primary" id="checkAvailabilityButton" class="payment-button" mat-raised-button [disabled]="!product?.isAvailable || _buttonDisabled">{{'SEE_OPTIONS' | translate}}</button>
            </div>
        </div>
        <div *ngIf="isHopOffHopOn" class="travelling-later" text-color="gray-dark">
            {{'TICKETS_VALID' | translate }}
        </div>
        </mat-card-content>
</mat-card>
